<template>
<section class="blockquote-slider px-4 py-24 vt:py-40">
    <div class="max-w-5xl mx-auto relative">

        <SmoothLoader tag="img" class="tl absolute" aria-hidden="true" src="/wp-content/themes/landslide/img/tl.png"></SmoothLoader>
        
        <SmoothLoader tag="img" src="/wp-content/themes/landslide/img/br.png" aria-hidden="true" class="br absolute"></SmoothLoader>

        <div class="max-w-xl mx-auto">

            <SmoothLoader tag="h2" v-if="headline" class="transform -rotate-2 font-headline text-3xl vt:text-5xl font-bold mb-6 vt:mb-12 text-secondary-600 text-center leading-tight" v-html="headline"></SmoothLoader>

            <SmoothLoader class="slide relative" :class="appState">

                <div class="text z-20">
                    <blockquote class="relative text-center">
                        <p class="quote-body font-accent w-full font-black text-3xl text-gray-800 relative z-20" v-html="'&ldquo;' + activeSlide.body + '&rdquo;'">
                        </p>

                        <cite class="citation not-italic block my-12 w-full text-gray-750 font-bold font-body text-lg" v-html="citation"></cite>
                    </blockquote>
                </div>
            </SmoothLoader>

            <div class="controls px-4 pb-8 mt-4">
                <ul class="flex justify-center">
                    <li v-for="(slide, i) in slides" class="mx-1">
                        <button @click="switchTo(i)" :class="{'active': i == activeIndex}" class="w-4 h-4 rounded-full bg-gray-750 inline-block">
                            <span class="sr-only">Go to slide {{ i + 1 }}</span>
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import { computed, ref } from 'vue';

export default {

    props: ['data'],

    setup(props) {

        const appState = ref('idle');
        const activeIndex = ref(0);
        const slides = props.data.quotes;

        const activeSlide = computed(() => {
            return slides[activeIndex.value];
        });

        const switchTo = async (i) => {
            appState.value = 'switching';
            await window.wait(300);
            activeIndex.value = i;
            appState.value = 'idle';
        };

        const citation = computed(() => {
            if (!activeSlide.value) {
                return null;
            }
            let output = '&mdash; ' + activeSlide.value.citation_name;
            if (activeSlide.value.citation_title) {
                output = output + `,<br>${activeSlide.value.citation_title}`;
            }
            return output;
        });

        return {
            appState,
            activeIndex,
            activeSlide,
            slides,
            switchTo,
            headline: props.data.headline || null,
            citation
        }

    }

    
}

</script>